import { Component, OnInit } from '@angular/core';
import { PropuestasService } from '../../providers/propuestas.service';

@Component({
  selector: 'app-integraciones',
  templateUrl: './integraciones.component.html',
  styleUrls: ['./integraciones.component.scss']
})
export class IntegracionesComponent implements OnInit {

  urlIntegracionZapier = null;
  constructor(
    private _propuestasService: PropuestasService,
  ) { }

  ngOnInit() {

    this._propuestasService.getUrlZapier().subscribe(
      respuesta => {
        //Seteo para mostrar en el html la url
        this.urlIntegracionZapier = respuesta.mensaje;
      }
    )
  }

  copyLinkToClipboard() {
    var txtArea = document.createElement("textarea");
    txtArea.id = 'txt';
    txtArea.style.position = 'fixed';
    txtArea.style.top = '0';
    txtArea.style.left = '0';
    txtArea.style.opacity = '0';
    txtArea.value = this.urlIntegracionZapier;
    document.body.appendChild(txtArea);
    txtArea.select();

    try {
      var successful = document.execCommand('copy');
      var msg = successful ? 'successful' : 'unsuccessful';
      // console.log('Copying text command was ' + msg);
      if (successful) {
        return true;
      }
    } catch (err) {
      // console.log('Oops, unable to copy');
    } finally {
      document.body.removeChild(txtArea);
    }
    return false;
  }

}
